export default "__VITE_ASSET__B8BcU6PW__"